import { Divider } from "@mui/material";
import { GroupChatListPanelHeaderWrapper } from "../patient/PatientChats.styles";
import { GroupChatListPanelHeader } from "../../GroupChatListPanelHeader";
import { useContext } from "react";
import { InternalChatsContext } from "hhn-commons";
import InternalGroupChatList from "./InternalGroupChatList";

type InternalChatListPanelProps = {
  unreadChatCount: number;
  selectedChatId?: string;
};

export const InternalChatListPanel = ({
  selectedChatId,
  unreadChatCount,
}: InternalChatListPanelProps) => {
  const { chatData, fetchChats, isChatLoading } =
    useContext(InternalChatsContext);

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={unreadChatCount}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <InternalGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
